/**
 *  websitetoBeCompiledModuleModule
 *
 * Description 网站渠道 待编
 * rebuild: wang.jiang 2016-3-4
 */
'use strict';
angular
    .module('websitetoBeCompiledModule', [
        'websitetoBeCompiledRouterModule',
        'editingCenterCompiledWebsiteTimingSignModule',
        'editingCenterCompiledWebsiteRecycleModule',
        'websiteAtlasModule',
        'websiteLinkDocModule',
        'websiteSubjectModule',
        'initWebsiteDataModule',
        'editingCenterWebsiteOwnerModule',
        'editPageChannelHandle',
        'websiteVideoModule',
    ])
    .controller('websitetoBeCompiledCtrl', [
        '$scope',
        'previewService',
        '$filter',
        '$q',
        '$state',
        '$stateParams',
        '$window',
        'trsHttpService',
        'initSingleSelecet',
        'modalDialog',
        'trsspliceString',
        'editingCenterService',
        'websiteService',
        'storageListenerService',
        'editcenterRightsService',
        'globleParamsSet',
        'editIsLock',
        'trsPrintService',
        'sensitiveWordCheckService',
        'localStorageService',
        'websiteConst',
        'newMediaService',
        'editingMediatype',
        function toBeCompiled(
            $scope,
            previewService,
            $filter,
            $q,
            $state,
            $stateParams,
            $window,
            trsHttpService,
            initSingleSelecet,
            modalDialog,
            trsspliceString,
            editingCenterService,
            websiteService,
            storageListenerService,
            editcenterRightsService,
            globleParamsSet,
            editIsLock,
            trsPrintService,
            sensitiveWordCheckService,
            localStorageService,
            websiteConst,
            newMediaService,
            editingMediatype
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description] null
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: globleParamsSet.getPageSize(),
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.childStatus = {
                    // 图片数组的string
                    checkString: 'DOC_PICTURELIST',
                    // 图片数组中表示url地址的string
                    picString: 'SRCPICURL',
                    originPicUrl: 'SRCPICURL',
                };
                $scope.status = {
                    isAllColumn: $state.params.channelid === '0',
                    hasRequestBtnRights: {},
                    isESSearch: false,
                    onlyMine: false,
                    onlyCurChannel: true,
                    btnRights: {},
                    hasphoto: false, // 是否是图集稿
                    hasphotoflag: true, // 判断是否人为点击图集切换模式
                    copyCurrPage: 1,
                    batchOperateBtn: {
                        hoverStatus: '',
                        clickStatus: '',
                    },
                    icon: {
                        noVideo: '0',
                        noAudio: '0',
                        noPic: '0',
                    },
                    detailMethodname: {
                        1: 'getNewsDoc',
                        2: 'getPicsDoc',
                        3: 'getSpecialDoc',
                        4: 'getLinkDoc',
                    },
                    draftType: {
                        news: '1',
                        atlas: '2',
                        subject: '3',
                        linkDoc: '4',
                        video: '7',
                    },
                    signedSuccess: false,
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    printResult: [],
                    editPath: websiteService.getEditandPreviewPath().edit,
                    previewPath: websiteService.getEditandPreviewPath().preview,
                    file: '',
                    trench: websiteConst.listenStroageKey,
                };
                $scope.params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryToBeCompiledDoc',
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    ChannelId: $stateParams.channelid, // 9
                    SiteId: $stateParams.siteid,
                    timeType: '',
                    DocId: '',
                    IsCurrentChnl: true,
                };

                // 监听未保存的专题分组，并删除
                $window.addEventListener('storage', function (e) {
                    var draftInfo = localStorageService.get('websiteUnsavedGroup');
                    if (draftInfo && draftInfo.specialGroupIds) {
                        localStorageService.remove('websiteUnsavedGroup');
                    }
                });
            }

            /**
             * [initData description]初始化数据
             * @return {[type]} [description] null
             */
            function initData() {
                if (!angular.isDefined($stateParams.siteid)) {
                    return;
                } // 如果没有站点，不进行初始化请求
                if (!angular.isDefined($stateParams.channelid)) {
                    return;
                } // 如果没有栏目id，不进行初始化请求
                if (!$scope.status.isAllColumn) {
                    saveVideoMode();
                    editcenterRightsService.initWebsiteListBtn('web.daibian', $stateParams.channelid).then(function (rights) {
                        $scope.status.btnRights = rights;
                    });
                    editingCenterService.getChannelDetail($stateParams.channelid).then(function (data) {
                        $scope.data.getChannelDetail = data;
                    });
                } else {
                    $scope.status.btnRights = websiteService.initDaiBianBtnRight();
                    // 在所有栏目下则不传ChannelId
                    delete $scope.params.ChannelId;
                    $scope.params.IsLoadAllChnl = true;
                }
                initDropList();
                // requestData();
                listenStorage();
            }

            // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
            $scope.requestData = function () {
                requestData();
            };

            /**
             * [saveVideoMode description] 记录视频模式
             * @return {[type]} [description]
             */
            function saveVideoMode() {
                let videoMode = localStorageService.get('websiteListVideomode') == '1';
                if (videoMode) {
                    $scope.data.selectedDocType = {
                        name: '视频',
                        value: 7,
                    };
                    $scope.params.docType = 7;
                }
                $scope.$watch('data.selectedDocType', (newV, oldV) => {
                    if (newV.value == 7) {
                        localStorageService.set('websiteListVideomode', '1');
                    } else {
                        localStorageService.set('websiteListVideomode', '0');
                    }
                });
            }

            /**
             * [videoMode description] 视频模式
             * @return {[type]} [description]
             */
            $scope.videoMode = function () {
                if ($scope.data.selectedDocType.value == 7) {
                    $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
                } else {
                    $scope.data.selectedDocType = {
                        name: '视频',
                        value: '7',
                    };
                }
                $scope.queryByDropdown('docType', $scope.data.selectedDocType.value);
            };

            /**
             * [draftImport description]导入文档
             * @return {[type]} [description]
             */
            $scope.draftImport = function () {
                $scope.status.isESSearch = false;
                $scope.loadingPromise = editingCenterService.draftImport(
                    'mlf_extmyrelease',
                    'websiteImportDoc',
                    $stateParams.channelid,
                    $scope.data.file,
                    function () {
                        requestData();
                    },
                    function () {
                        delete $scope.data.file;
                    }
                );
            };

            // 下一页
            $scope.pageChanged = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /* 跳转指定页面*/
            $scope.jumpToPage = function () {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.params.CurrPage;
                requestData();
            };

            /**
             * [selectPageNum description]选择单页显示条数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function () {
                $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.params.PageSize = $scope.page.PAGESIZE;
                $scope.status.copyCurrPage = 1;
                requestData();
            };

            // 全选
            $scope.selectAll = function () {
                $scope.data.selectedArray =
                    $scope.data.selectedArray.length == $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
            };
            // 单选
            $scope.selectDoc = function (item) {
                var index = $scope.data.selectedArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice(index, 1);
                }
                judgeAuthority(item);

            };

            /**
             * [judgeAuthority description]所以栏目下勾选权限请求
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function judgeAuthority(item) {
                if (!$scope.status.isAllColumn) {
                    return;
                }
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.btnRights = websiteService.initDaiBianBtnRight();
                    return;
                }

                if (!$scope.status.hasRequestBtnRights[item.CHANNELID]) {
                    $scope.loadingPromise = editcenterRightsService.initWebsiteListBtn('web.daibian', item.CHANNELID).then(function (rights) {
                        $scope.status.hasRequestBtnRights[item.CHANNELID] = rights;
                        // dealQx();
                        $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.status.hasRequestBtnRights);
                    });
                } else {
                    // dealQx();
                    $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.status.hasRequestBtnRights);
                }


                // 当前是否是所有栏目 是则判断item的栏目id 是否是请求过的（是否在对象key中），没有则请求权限 {123：obj}、
                // 取对象交集作为权限
            }

            /**
             * [draftPublish description]稿件预览
             * @param  {[obj]} item [description]稿件信息结合
             * @return {[type]}      [description]
             */
            $scope.draftPublish = function (item) {
                $scope.status.isESSearch = false;
                editingCenterService.draftPublish(item.CHNLDOCID);
            };

            /**
             * [trial description]送审
             * @param  {[type]} item [description] 如果传入代表单个稿件收藏，不传代表批量操作
             * @return {[type]}      [description] null
             */
            $scope.trial = function (item) {
                $scope.status.isESSearch = false;
                trial();
            };

            /**
             * [share description] 共享操作
             * @param  {[type]} item [description]  如果传入代表单个稿件收藏，不传代表批量操作
             * @return {[type]}      [description]
             */
            $scope.share = function (item) {
                $scope.status.isESSearch = false;
                var chnlDocIds, metaDataIds;
                if (!!item) {
                    chnlDocIds = item.CHNLDOCID;
                    metaDataIds = item.METADATAID;
                } else {
                    chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                    metaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                }
                share(chnlDocIds, metaDataIds);
            };

            /**
             * [share description]共享方法
             * @param  {[type]} chnldocids  [description] 多个chnldocid 以逗号隔开
             * @param  {[type]} metadataids [description] 多个metadataid  以逗号隔开
             * @return {[type]}             [description]
             */
            function share(chnldocids, metadataids) {
                editingCenterService.share(function (data) {
                    data.serviceid = 'mlf_websiteoper';
                    data.methodname = 'doShareDAIBIAN';
                    data.ChnlDocIds = chnldocids;
                    data.MetaDataIds = metadataids;
                    data.ChannelId = $stateParams.channelid;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function (data) {
                        modalDialog.alertType('操作成功', '', 'success', false);
                        requestData();
                    });
                });
            }

            /**
             * [draftlist description]发稿单
             * @return {[type]} [description] null
             */
            $scope.draftlist = function () {
                $scope.status.isESSearch = false;
                newMediaService.draftlist($scope, websiteConst.draftListDB, websiteConst.draftListQuery);
                // editingCenterService.draftList(
                //     $scope.data.selectedArray,
                //     {
                //         serviceid: 'mlf_appfgd',
                //         methodname: 'webDaiBianbatchUpdateFgdUsers',
                //     },
                //     function() {
                //         $scope.data.selectedArray = [];
                //     }
                // );
            };

            /**
             * [copyDraft description]复制稿件
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.copyDraft = function (item) {
                $scope.status.isESSearch = false;
                if (!!item) {
                    copyDraft([item]);
                } else {
                    copyDraft($scope.data.selectedArray);
                }
            };

            /**
             * [moveDraft description]移动稿件
             * @param  {[type]} item [description]如果传入代表单个稿件收藏，不传代表批量操作
             * @return {[type]}      [description]
             */
            $scope.moveDraft = function (item) {
                $scope.status.isESSearch = false;
                if (!!item) {
                    moveDraft([item]);
                } else {
                    moveDraft($scope.data.selectedArray);
                }
            };

            /**
             * [goToDetail description]图集模式跳转细览页
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.goToDetail = function (item) {
                $scope.websitePreview(item);
                var params = {
                    wzchannelid: item.CHANNELID,
                    wzchnldocid: item.CHNLDOCID,
                    wzsiteid: $scope.params.SiteId,
                    wzmetadataid: item.METADATAID,
                    wzplatform: 0,
                    wztypeid: item.DOCTYPEID,
                    isawaitrevise: item.WEBSTATUSNAME === '待修订' ? 'isAwaitRevise' : '',
                };
                var url = $state.href('websitePreviewAll', params);
                window.open(url);
            };

            /**
             * [collect description] 稿件收藏
             * @param  {[type]} item [description] 如果传入代表单个稿件收藏，不传代表批量操作
             * @return {[type]}      [description]
             */
            $scope.collect = function (item) {
                if (editcenterRightsService.judgeCanBeCollected($scope.data.selectedArray)) {
                    modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                    return;
                }
                $scope.status.isESSearch = false;
                collectDraft();
            };

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenWebsite(function () {
                    $scope.status.isESSearch = false;
                    requestData();
                    storageListenerService.removeListener('website');
                }, $scope);
            }

            /**
             * [requestData description] 数据请求
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params; // 906
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var ListItems = data.DATA;
                    $scope.data.items = ListItems;
                    if ($scope.data.selectedDocType) {
                        if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2' && $scope.status.hasphotoflag === true) {
                            $scope.status.hasphoto = true;
                        } else {
                            $scope.status.hasphoto = false;
                        }
                    }
                    $scope.data.filterReviseItem = ListItems.filter((item) => item.WEBSTATUSNAME !== '待修订');
                    !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                    $scope.data.selectedArray = [];
                    requestListImg(ListItems).then(function (data) {
                        angular.forEach(ListItems, function (value, key) {
                            value.ALLIMG = data[value.METADATAID];
                        });
                    });
                    newMediaService.getReviseInfo(ListItems);
                    getVideoInfo();
                });
            }

            /**
             * [getVideoInfo description] 获取稿件视频信息
             * @return {[type]} [description]
             */
            function getVideoInfo() {
                $scope.data.videoInfo = '';
                if ($scope.data.selectedDocType.value != 7) {
                    return;
                }
                let deffer = $q.defer();
                let params = {
                    serviceid: 'mlf_website',
                    methodname: 'queryAllAppendixVideo',
                    MetadataIds: $scope.data.items.map((item) => item.METADATAID).join(','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.videoInfo = data;
                });
            }

            /**
             * [playVideo description] 播放视频
             * @param  {[type]} item [description] 稿件信息
             * @return {[type]}      [description]
             */
            $scope.playVideo = function (item) {
                let videoInfo = $scope.data.videoInfo[item.METADATAID];
                previewService.videoPlayer(videoInfo.AUDIOVIDEOID, '3', item.TITLE);
            };

            /**
             * [requestListImg description]查询图示列表
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            function requestListImg(items) {
                var defer = $q.defer();
                if (!items || items.length < 1) {
                    defer.resolve([]);
                } else {
                    var params = {
                        serviceid: 'mlf_myrelease',
                        methodname: 'queryAllImgLogo',
                        metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            }

            /**
             * [initDropList description] 初始化下拉框
             * @return  {[type]}  [return description]
             */
            function initDropList() {
                $scope.data.docTypeArray = initSingleSelecet.websiteDocType();
                $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
                $scope.data.timeTypeArray = initSingleSelecet.chooseTimeType();
                $scope.data.selectedTimeType = angular.copy($scope.data.timeTypeArray[0]);
                // 初始化搜索框边的下拉框
                $scope.data.iWoAll = initSingleSelecet.iWoEntire();
                $scope.data.iWoAllSelected = angular.copy($scope.data.iWoAll[0]);
                // 排序方式
                $scope.sortTypeJsons = initSingleSelecet.sortType();
                $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
                // editingCenterService.dealStorage($scope);
            }

            /**
             * [queryByDropdown description] 筛选条件触发后请求数据
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */
            $scope.queryByDropdown = function (key, value) {
                $scope.params[key] = value;
                $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                if (key == 'timeType') {
                    $scope.params.OperTimeStart = $scope.data.fromdate;
                    $scope.params.OperTimeEnd = $scope.data.untildate;
                    $scope.params[key] = null;
                }
                // 下拉框判断
                if (key === 'docType' && value === '2') {
                    $scope.status.hasphotoflag = true;
                }
                requestData();
            };

            /**
             * [trial description]送审开始
             *
             * @param   {[type]}  chnlDocIds   [chnlDocIds description]
             * @param   {[type]}  metaDataIds  [metaDataIds description]
             *
             * @return  {[type]}               [return description]
             */
            function trial() {
                var temp = $filter('pick')($scope.data.selectedArray, $scope.filterChannelId);
                if (temp.length === $scope.data.selectedArray.length) {
                    $scope.loadingPromise = newMediaService.trial($scope, websiteConst.trial);
                } else {
                    modalDialog.alertType('稿件送审失败', '所选稿件不属于同一栏目', 'error', false);
                }
            }

            /**
             * [collectDraft description]收藏稿件方法
             * @param  {[type]} chnldocids [description] 稿件chnldocids
             * @return {[type]}            [description]
             */
            function collectDraft() {
                var temp = $filter('pick')($scope.data.selectedArray, $scope.filterChannelId);
                if (temp.length === $scope.data.selectedArray.length) {
                    $scope.loadingPromise = newMediaService.collect($scope, websiteConst.collectDB);
                } else {
                    modalDialog.alertType('收藏失败', '所选稿件不属于同一栏目', 'error', false);
                    $scope.data.selectedArray = [];
                }
            }

            /**
             * [timeSign description] 定时签发操作
             * @return  {[type]}  [return description]
             */
            $scope.timeSign = function () {
                $scope.status.isESSearch = false;
                sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.data.selectedArray).then(
                    function () {
                    },
                    function () {
                        timeSign();
                    }
                );
            };

            /**
             * [timeSign description]定时签发函数
             * @return  {[type]}         [return description]
             */
            function timeSign() {
                $scope.loadingPromise = newMediaService.timeSign($scope, websiteConst.daibianTimeSign, signCallBack);
            }

            /**
             * [signCallBack description] 签发回调
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  array   [array description]
             * @return  {[type]}          [return description]
             */
            function signCallBack(params, array) {
                var ChnlDocIds = [];
                var ObjectIds = [];
                var MetaDataIds = [];
                for (var i = 0; i < array.length; i++) {
                    ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                    ObjectIds.push(array[i].DOC.CHNLDOCID);
                    MetaDataIds.push(array[i].DOC.METADATAID);
                }
                params.ChnlDocIds = ChnlDocIds.join(',');
                params.ObjectIds = ObjectIds.join(',');
                params.MetaDataIds = MetaDataIds.join(',');
            }

            /**
             * [directSign description] 直接签发
             * @return  {[type]}  [return description]
             */
            $scope.directSign = function () {
                $scope.status.isESSearch = false;
                sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.selectedArray, '', 2).then(
                    function () {
                        $scope.status.signedSuccess = true;
                        directSign();
                    },
                    function () {
                        directSign();
                    }
                );
            };

            /**
             * [directSign description] 签发函数
             * @return  {[type]}              [return description]
             */
            function directSign() {
                $scope.loadingPromise = newMediaService.sign($scope, websiteConst.daibianSign, signCallBack);
            }

            /**
             * [delete description] 废稿
             * @return {[type]}      [description]
             */
            $scope.delete = function () {
                $scope.status.isESSearch = false;
                abandonDraft();
            };

            /**
             * [abandonDraft description]废稿函数
             * @return {[type]}            [description]
             */
            function abandonDraft() {
                newMediaService.delete($scope, websiteConst.delete);
            }

            /**
             * [isOnlyMine description]只看我的
             * @return {Boolean} [description] null
             */
            $scope.isOnlyMine = function () {
                $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.onlyMine = !$scope.status.onlyMine;
                $scope.params.isOnlyMine = $scope.status.onlyMine;
                requestData();
            };

            /**
             * [isOnlyCurChannel description]只看当前栏目
             * @return {Boolean} [description] null
             */
            $scope.isOnlyCurChannel = function () {
                $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
                $scope.status.onlyCurChannel = !$scope.status.onlyCurChannel;
                $scope.params.IsCurrentChnl = $scope.status.onlyCurChannel;
                requestData();
            };

            /**
             * [copyDraft description]复制建新稿
             * @param  {[type]} items [description]  稿件集合
             * @return {[type]}       [description]
             */
            function copyDraft(items) {
                var isCurrChnl = true;
                for (var i = 0; i < items.length; i++) {
                    if (items[i].CHNLID != $stateParams.channelid) {
                        isCurrChnl = false;
                        break;
                    }
                }
                if (!isCurrChnl) {
                    modalDialog.alertType('无法复制', '不能对子栏目的稿件进行复制操作', 'error', false);
                    return;
                } else {
                    websiteService.batChooseChnl('复制稿件', $stateParams.siteid, 1, function (data) {
                        var params = {
                            serviceid: 'mlf_websiteoper',
                            methodname: 'copyDAIBIANDoc',
                            ChannelId: $stateParams.channelid,
                            MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                            ChannelIds: data.ChannelIds,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                            modalDialog.alertType('复制稿件成功', '', 'success', false);
                            requestData();
                        });
                    });
                }
            }

            /**
             * [selectedChannelId description]过滤器过滤移动稿件CHANNELID不相同的情况
             * @param  {[type]} elm [description]传入的值
             * @return {[type]}     [description]
             */
            $scope.filterChannelId = function (elm) {
                if (angular.isDefined(elm.CHANNELID)) {
                    return elm.CHANNELID == $scope.data.selectedArray[0].CHANNELID;
                }
            };

            /**
             * [moveDraft description] 移动稿件
             * @param  {[type]} items [description] 稿件结合
             * @return {[type]}       [description] null
             */
            function moveDraft(items) {
                var temp = $filter('pick')(items, $scope.filterChannelId);
                if (temp.length === items.length) {
                    var channelids = trsspliceString.spliceString(items, 'CHANNELID', ',');
                    websiteService.singleChooseChnl('移动稿件', $stateParams.siteid, $stateParams.channelid, channelids, 1, function (data) {
                        var params = {
                            serviceid: 'mlf_websiteoper',
                            methodname: 'moveDAIBIANDoc',
                            SrcChannelId: items[0].CHANNELID,
                            ChnlDocIds: trsspliceString.spliceString(items, 'CHNLDOCID', ','),
                            ToChannelId: data.channelid,
                            moveMode: 0,
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                            modalDialog.alertType('稿件移动成功', '', 'success', false);
                            requestData();
                        });
                    });
                } else {
                    modalDialog.alertType('稿件移动失败', '所选稿件不属于同一栏目', 'error', false);
                }
            }

            /**
             * [showVersionTime description]展示流程版本与操作日志
             * @param  {[object]} item [description] 稿件信息
             * @return {[type]}        [description]
             */
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            // 邮件外发
            $scope.outSending = function (item) {
                if (!selectDraftTip()) {
                    return;
                }
                if (checkDraftType($scope.status.draftType.video)) {
                    modalDialog.alertType('所选稿件中含有视频稿，无法外发', '', 'error', 'confirm');
                    return;
                }
                $scope.status.isESSearch = false;
                editingCenterService.outSending('', function (result) {
                    outSendingDraft(result.selectItems, item);
                });
            };

            /**
             * [outSendingDraft description] 邮件外发
             * @param   {[type]}  items  [items description]
             * @param   {[type]}  item   [item description]
             * @return  {[type]}         [return description]
             */
            function outSendingDraft(items, item) {
                var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
                var draftids = trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'METADATAID', ',');
                var params = {
                    serviceid: 'mlf_mailoutgoingOper',
                    methodname: 'webDaiBianSendEmail',
                    Emails: userids,
                    MetaDataIds: draftids,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                            requestData();
                        });
                    },
                    function () {
                        $scope.data.selectedArray = [];
                    }
                );
            }

            /**
             * [getESSearchParams description]设置ES检索参数
             * @return {[json]} [description] 参数对象
             */
            function getESSearchParams() {
                var esParams = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForWebSiteToBeCompiledDoc',
                    searchParams: {
                        PAGESIZE: $scope.page.PAGESIZE + '',
                        PAGEINDEX: $scope.page.CURRPAGE + '',
                        searchFields: [
                            {
                                searchField: $scope.data.iWoAllSelected.value,
                                keywords: $scope.keywords ? $scope.keywords : '',
                            },
                            {
                                searchField: 'docType',
                                keywords: $scope.data.selectedDocType ? $scope.data.selectedDocType.value : '',
                            },
                            {
                                searchField: 'timeType',
                                keywords:
                                    angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                        ? $scope.data.fromdate + ',' + $scope.data.untildate
                                        : $scope.data.selectedTimeType.value,
                            },
                            {
                                searchField: 'isOnlyMine',
                                keywords: $scope.status.onlyMine,
                            },
                            {
                                searchField: 'isOnlyCurChannel',
                                keywords: $scope.status.onlyCurChannel,
                            },
                            {
                                searchField: 'channelid',
                                keywords: $stateParams.channelid,
                            },
                            {
                                searchField: '_sort',
                                keywords: $scope.sortType.value,
                            },
                        ],
                    },
                };
                // 所有栏目下  不传channelid 传siteid
                if ($scope.status.isAllColumn) {
                    esParams.searchParams.searchFields[5] = {
                        searchField: 'siteid',
                        keywords: $stateParams.siteid,
                    };
                    // 搜索的时候也要初始化一下权限
                    $scope.status.btnRights = websiteService.initDaiBianBtnRight();
                }
                esParams.searchParams = JSON.stringify(esParams.searchParams);
                return esParams;
            }

            /**
             * [fullTextSearch description]全文检索
             *
             * @param   {[type]}  ev  [ev description]
             *
             * @return  {[type]}      [return description]
             */
            $scope.fullTextSearch = function (ev) {
                if ($scope.data.iWoAllSelected.value === 'DocID') {
                    $scope.status.isESSearch = false;
                    $scope.params.DocId = $scope.keywords;
                } else {
                    $scope.status.isESSearch = true;
                }
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.page.CURRPAGE = 1;
                    requestData();
                }
            };

            /**
             * [quote description]引用
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.quote = function (item) {
                $scope.status.isESSearch = false;
                var selectedArray;
                if (!!item) {
                    selectedArray = [item];
                } else {
                    selectedArray = $scope.data.selectedArray;
                }
                quoteItem(selectedArray);
            };

            /**
             * [quoteItem description]
             *
             * @param   {[type]}  array  [array description]
             *
             * @return  {[type]}         [return description]
             */
            function quoteItem(array) {
                websiteService.batChooseChnl('引用', $stateParams.siteid, 1, function (data) {
                    var params = {
                        serviceid: 'mlf_websiteoper',
                        methodname: 'DaiBianQuoteDoc',
                        ChnlDocIds: trsspliceString.spliceString(array, 'CHNLDOCID', ','),
                        ChannelIds: data.ChannelIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('引用成功', '引用成功', 'success', false, function () {
                            $scope.data.selectedArray = [];
                            requestData();
                        });
                    });
                });
            }

            /**
             * [routerToEdit description]编辑前请求解锁
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.routerToEdit = function (item) {
                $scope.status.isESSearch = false;
                let editUrl = packageRouterParams(item);
                if (angular.isObject(item)) {
                    editIsLock.isLock(item, editingMediatype.website).then(function (data) {
                        if (data.ISLOCK === 'false') {
                            $window.open(editUrl);
                        } else {
                            editIsLock.checkUnlockPermissions(item, data).then(function () {
                                $window.open(editUrl);
                            });
                        }
                    });
                } else {
                    $window.open(editUrl);
                }
            };

            /**
             * [packageRouterParams description] 组装路由参数
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function packageRouterParams(item) {
                let editPath = $scope.data.editPath[item.DOCTYPEID || item];
                let editParams = {
                    wzchannelid: $state.params.channelid,
                    wzchnldocid: item.CHNLDOCID,
                    wzmetadataid: item.METADATAID,
                    wzsiteid: $state.params.siteid,
                    wzplatform: 0,
                };
                return $state.href(editPath, editParams);
            }


            /**
             * [printBtn description]打印
             * @return  {[type]}  [return description]
             */
            $scope.printBtn = function () {
                if (!selectDraftTip()) {
                    return;
                }
                if (checkDraftType($scope.status.draftType.subject) || checkDraftType($scope.status.draftType.video)) {
                    modalDialog.alertType('所选稿件中有专题稿或视频稿，无法打印', '', 'error', 'confirm');
                    return;
                }
                $scope.status.isESSearch = false;
                angular.forEach($scope.data.selectedArray, function (value, key) {
                    requestPrintData(value);
                });
            };

            /**
             * [atlasMode description] 图集模式
             * @return {[type]} [description]
             */
            $scope.atlasMode = function () {
                // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
                $scope.status.hasphoto = !$scope.status.hasphoto;
                $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
            };

            /**
             * [checkDraftType description] 检查是否选中了某种类型的稿件
             * @param   {[type]}  typeId  [typeId description]
             * @return  {[type]}          [return description]
             */
            function checkDraftType(typeId) {
                var flag = false;
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].DOCTYPEID == typeId) {
                        flag = true;
                        break;
                    }
                }
                return flag;
            }


            /**
             * [requestPrintData description]description：打印请求详情
             * @param   {[type]}  item     [item description]
             * @param   {[type]}  version  [version description]
             * @return  {[type]}           [return description]
             */
            function requestPrintData(item, version) {
                var params = {
                    serviceid: 'mlf_website',
                    methodname: $scope.status.detailMethodname[item.DOCTYPEID],
                    MetaDataId: item.METADATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var result = data;
                    data.VERSION = version;
                    data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                        trsPrintService.trsWebPrintDocument($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            }

            /**
             * [exportDraft description] 导出稿件
             * @return  {[type]}  [return description]
             */
            $scope.exportDraft = function () {
                if (!selectDraftTip()) {
                    return;
                }
                $scope.status.isESSearch = false;
                if (
                    checkDraftType($scope.status.draftType.subject) ||
                    checkDraftType($scope.status.draftType.linkDoc) ||
                    checkDraftType($scope.status.draftType.video)
                ) {
                    modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                    return;
                }
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportWordFile',
                    MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function (data) {
                        window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        $scope.data.selectedArray = [];
                    },
                    function (data) {
                        if (data.REPORTS[0].ISSUCCESS == 'true') {
                            window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            $scope.data.selectedArray = [];
                        }
                    }
                );
            };

            /**
             * [websitePreview description] 预览页
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.websitePreview = function (item) {
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID,CHANNELID', 'websitePreview');
            };

            /**
            * [manuscriptShare description]稿件分享
            *
            * @param   {[type]}  item  [item description]
            *
            * @return  {[type]}        [return description]
            */
            $scope.manuscriptShare = function (item) {
                $scope.loadingPromise = editingCenterService.manuscriptShare(item, function (data) {
                    requestData();
                });
            };

            /**
             * [revise description]修订
             * @return {[type]} [description]
             */
            $scope.revise = function () {
                var transferData = {
                    serviceid: 'mlf_modifydoc',
                    methodname: 'appointDocToUserOfWebDaiBian',
                    SiteId: $stateParams.siteid,
                    DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                    UserId: '',
                };
                newMediaService.revise($scope, transferData);
            };


            /** 多元分发
             * [distribution description]
             * @return {[type]} [description]
             */
            $scope.distribution = function () {
                $scope.status.isESSearch = false;
                if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')) {
                    modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                    return;
                }
                var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
                if (temp.length < 1) {
                    editingCenterService.distribution($scope.data.selectedArray, '2', $scope.data.selectedArray[0].DOCTYPEID, 'webDaiBianDistribute', function () {
                        $scope.data.selectedArray = [];
                        requestData();
                    });
                } else {
                    modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、图集、视频', 'warning', 'confirm');
                }
            };

            /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
             * [examDistributionType description]
             * @param  {[type]} elm [description]
             * @return {[type]}     [description]
             */
            $scope.examDistributionType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2 && elm.DOCTYPEID != 7;
                }
            };

            /**
             * [selectDraftTip description] 选择稿件提示
             * @return {[boolean]} [description]
             */
            function selectDraftTip() {
                var flag = true;
                if ($scope.data.selectedArray.length === 0) {
                    flag = false;
                    modalDialog.alertType('请先选择稿件', '', 'warning', 'confirm');
                }
                return flag;
            }
        },
    ]);
